import React, { useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { useOpenUnsavedChangesModal } from 'seagull';
const compareLocation = (locationA, locationB) => {
  return locationA.pathname === locationB.pathname && locationA.search === locationB.search && locationA.hash === locationB.hash;
};
export function NavigationGuardModal(_ref) {
  let {
    when,
    primaryButtonTestId,
    secondaryButtonTestId
  } = _ref;
  const openUnsavedChangesModal = useOpenUnsavedChangesModal();
  const history = useHistory();
  const [lastNavigation, setLastNaviation] = useState(null);
  return /*#__PURE__*/React.createElement(Prompt, {
    when: when,
    message: nextLocation => {
      if (lastNavigation && compareLocation(lastNavigation, nextLocation)) {
        return true;
      } else {
        openUnsavedChangesModal({
          primaryButtonTestId,
          secondaryButtonTestId
        }).then(confirmedNavigation => {
          if (confirmedNavigation) {
            setLastNaviation(nextLocation);
            history.push(nextLocation);
          }
        });
        return false;
      }
    }
  });
}